import { PropsWithChildren } from 'react';
import { FormProvider } from 'react-hook-form';
import { isNil } from 'lodash-es';
import { usePlanCheckoutForm } from '../subscriptionPayment/hooks/usePlanCheckoutForm';
export const AdditionalPaymentFormProvider = ({
  children,
  zipCode
}: PropsWithChildren<defaultValues>) => {
  const methods = usePlanCheckoutForm({
    zipCode: isNil(zipCode) ? '' : zipCode
  });
  return <FormProvider {...methods} data-sentry-element="FormProvider" data-sentry-component="AdditionalPaymentFormProvider" data-sentry-source-file="AdditionalPaymentFormProvider.tsx">{children}</FormProvider>;
};
export type defaultValues = {
  zipCode: string | null;
};